module.exports = __webpack_public_path__ + "img/beijing03.86031976.png";